import { dateValidator, textValidator } from '../../../../../../components/Form/utils/validators';
import {
  itemInStockValidator,
} from '../../../../../assetsInventory/utils/rules';

export const RESERVE_FORM_RULES = {
  itemInStockSearch: {
    validate: textValidator('PROCURE_3030'),
  },
  itemInStock: itemInStockValidator,
  actorId: {
    validate: textValidator('PROCURE_3034'),
  },
  destinationId: {
    validate: textValidator('PROCURE_3016'),
  },
  startDate: {
    validate: dateValidator('PROCURE_3036'),
  },
  endDate: {
    validate: dateValidator('PROCURE_3037'),
  },
  quantity: { validate: textValidator('PROCURE_3022') },
};
